import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function BrandFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.025 2.007H21v11.835C21 18.747 17.41 22 12.013 22S3 18.747 3 13.842V2.007h4.064V2h9.961v.007zM8.137 10.14V8.322h1.329v4.856h-1.33v-1.923H5.982v1.923H4.652V8.322h1.33v1.818h2.155zm7.105-1.818h2.315c.866 0 1.448.525 1.448 1.319 0 .374-.194.696-.537.932.517.21.828.617.828 1.135 0 .88-.712 1.47-1.791 1.47h-2.263V8.322zm1.332 1.805h.653c.246 0 .407-.138.407-.348 0-.204-.155-.341-.375-.341h-.685v.689zm0 1.935h.866c.291 0 .485-.164.485-.413 0-.243-.194-.407-.472-.407h-.879v.82zm-2.08-3.738h-.95v-.002H11.16v.002h-.972v2.873c0 1.191.865 1.98 2.156 1.98 1.292 0 2.15-.789 2.15-1.98V8.325z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(BrandFill);
export default ForwardRef;